import { ProductionTypeAdditionalData, ProductionTypeInterface } from './production-type.interface';
import { ProductionType } from '../../../../../services/analysis.service';
import { SolarCalculatorRequest } from '../../../../models/analysis/solar-calculator-request';

export abstract class UserGivenProductionType implements ProductionTypeInterface {
  abstract getProductionType(): ProductionType;

  setRequestData(request: SolarCalculatorRequest, formValue: any, additionalData?: ProductionTypeAdditionalData) {
    request.googleLatLng = formValue.location;
    request.area = formValue.area;
    request.tilt = formValue.tilt;
    request.azimuth = formValue.azimuth;
  }

}
